export default __webpack_public_path__ + "static/media/flag-uganda.49a76f26.svg";